import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router, UrlTree } from '@angular/router';
import { Observable, of } from 'rxjs';
import { HasPermissionsResultDto } from '../dtos/auth/has-permissions-result-dto';
import { AuthTokenStorageService } from '../init/auth-token-storage.service';
import { ToastService } from '../shared/toast/toast.service';
import { makeUrl } from '../utils/global';
import { AuthInfo, LoginInfo } from './data';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  HAS_PERMISSIONS_URL: string = makeUrl("/auth/haspermissions");

  public checkRefreshError(): void {
    /*if(this.refreshService.hasRefreshLimitError())
      localStorage.setItem('isAuthenticated', 'false');*/
  }

  public get isAuthenticated(): boolean {
    return this.authTokenStorage.isAuthenticated();
  }

  public get isAuthenticationComplete(): boolean {
    return this.authTokenStorage.isAuthenticationComplete();
  }


  private _returnUrl: string = '';
  get returnUrl(): string {
    return this._returnUrl;
  }
  set returnUrl(value: string) {
    console.log('>>>>>>>' + value);
    this._returnUrl = value;
  }


  public returnUrlTree: UrlTree | null = null;

  private authUrl: string = makeUrl('/auth/login');
  private refreshUrl: string = makeUrl('/auth/refresh');

  private authInfo: AuthInfo | null = null;

  private autoRefreshTimeout: any;
  private AUTO_REFRESH_RETRY_TIME: number = 10000;

  constructor(private router: Router,
    private activatedRoute: ActivatedRoute,
    private http: HttpClient,
    private toast: ToastService,
    private authTokenStorage: AuthTokenStorageService) { }

  /*public initApp() {
    return this.refreshService.init();
  }*/

  public login(user: string, password: string): Observable<any> {
    if (this.returnUrl === 'login')
      this.returnUrl = '';

    let login: LoginInfo = new LoginInfo(user, password);

    return this.http.post<AuthInfo>(this.authUrl, login)/*.pipe(
      map((authInfo: AuthInfo) => {


        //************this.refreshService.initAutoRefresh(authInfo.auxTime);

        this.router.navigate([this.returnUrl]).then((v: boolean) => {
          localStorage.setItem('isAuthenticationComplete', 'true');
        });
      })
    )*/;
  }

  public fillAuthentication(authInfo: AuthInfo) {
    this.authInfo = authInfo;

    localStorage.setItem('isAuthenticated', 'true');
    localStorage.setItem('isAuthenticationComplete', 'false');
    localStorage.setItem('token', authInfo.token);
    localStorage.setItem('refreshToken', authInfo.refreshToken);
    localStorage.setItem('expiresAt', new Date(authInfo.expiresAt).toDateString());
    localStorage.setItem('auxTime', authInfo.auxTime + '');
  }

  public finalizeAuthentication() {
    localStorage.setItem('isAuthenticationComplete', 'true');
  }

  public logout() {
    //localStorage.clear();
    //this.refreshService.stopRefreshTimeout();

    //this.router.navigate(['login']);
  }

  /*public autoRefresh(expiresAt: string, resolve: any = null) {
    if(!localStorage.getItem('token') || localStorage.getItem('token') === '') {
      if(resolve)
        resolve();

      return;
    }

    let refresh = new RefreshRequestInfo(localStorage.getItem('token'), 
        localStorage.getItem('refreshToken'));

    this.http.post<RefreshResponseInfo>(this.refreshUrl, refresh).pipe(
      // Se ocorrer algum erro, faz mais 3 tentativas.
      retry(3)
    ).subscribe((r: RefreshResponseInfo) => {

      localStorage.setItem('isAuthenticated', 'true');
      localStorage.setItem('token', r.token);
      localStorage.setItem('expiresAt', new Date(r.expiresAt).toDateString());
      localStorage.setItem('auxTime', r.auxTime + '');

      console.log('END RECOVERY TOKEN ' + localStorage.getItem('token'));
      console.log(r);

      clearTimeout(this.autoRefreshTimeout);
      this.autoRefreshTimeout = setTimeout(() => {
        this.autoRefresh(localStorage.getItem('expiresAt'));
      }, r.auxTime);

      if(resolve)
        resolve();

      return r;
    },
    (err: any) => {
      // Se não conseguiu recuperar o token, tenta novamente.
      this.toast.showAuthError('Não foi possível atualizar a autenticação do usuário. Favor verificar a estabilidade da rede.');
      setTimeout(() => {
        this.autoRefresh(localStorage.getItem('expiresAt'));
      }, this.AUTO_REFRESH_RETRY_TIME);

      if(resolve)
        resolve();
    });
  }*/

  public refresh(): Observable<any> {
    return of([]);
    /*let refresh = new RefreshRequestInfo(localStorage.getItem('token'), 
        localStorage.getItem('refreshToken'));

    console.log('START RECOVERY');

    return this.http.post<RefreshResponseInfo>(this.refreshUrl, refresh).pipe(
      // Se ocorrer algum erro, faz mais 3 tentativas.
      retry(3),
      map((r: RefreshResponseInfo) => {

        localStorage.setItem('isAuthenticated', 'true');
        localStorage.setItem('token', r.token);
        localStorage.setItem('expiresAt', r.expiresAt.toDateString());
        localStorage.setItem('auxTime', r.auxTime + '');

        console.log('END RECOVERY TOKEN ' + localStorage.getItem('token'));
        console.log(r);

        return r;
      }),
      catchError((err: any) => {
        // Se não conseguiu recuperar o token, então logout.
        if(err.status === 401) {
          this.logout();
        }

        return throwError(err);
      })
    );*/

  }

  // se any = true, retorna true se o usuário tem pelo menos uma das permissões.
  // se any = false, return true apenas se o usuário possui todas as permissões.
  public hasPermissions(permissions: string[], any: boolean): Observable<HasPermissionsResultDto> {
    //return this.http.post<Aso>(this.URL, levantamentoInput);

    return this.http.post<HasPermissionsResultDto>(this.HAS_PERMISSIONS_URL, {
      permissions: permissions, any: any
    });
  }

}

